import React, { useEffect, useState } from "react";
import "./home.css";
import { Link } from "react-router-dom";
import Footer from "../../components/footer/Footer";

const API_BASE = process.env.REACT_APP_API_BASE;

const Home = () => {
  // ==========================================================
  // ESTADOS
  // ==========================================================
  const [carregandoSessao, setCarregandoSessao] = useState(true);
  const [logado, setLogado] = useState(false);
  const [nome, setNome] = useState("");

  // ==========================================================
  // CHECAR SESSÃO (HOME NÃO REDIRECIONA)
  // ==========================================================
  const checarSessao = async () => {
    try {
      const res = await fetch(`${API_BASE}/painel-dados.php`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data?.status === "sucesso") {
        setLogado(true);
        setNome(data?.nome || "");
      } else {
        setLogado(false);
        setNome("");
      }
    } catch {
      setLogado(false);
      setNome("");
    } finally {
      setCarregandoSessao(false);
    }
  };

  useEffect(() => {
    checarSessao();
  }, []);

  // ==========================================================
  // RENDER
  // ==========================================================
  return (
    <div className="home-page">
      {/* ======================================================
          HEADER
      ====================================================== */}
      <header className="home-header">
        <div className="home-header-inner">
          <img src="/assets/logo2.png" alt="NutriFácil" className="home-logo" />

          <div className="home-header-actions">
            {carregandoSessao ? null : logado ? (
              <Link
                to="/painel"
                className="home-header-btn home-header-btn--primary"
              >
                Acessar Painel
              </Link>
            ) : (
              <Link to="/login" className="home-header-btn">
                Entrar
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* ======================================================
          CONTEÚDO
      ====================================================== */}
      <main className="home-container">
        {carregandoSessao ? (
          <section className="home-hero home-hero--loading">
            <div className="home-hero-left">
              <div className="home-skel home-skel-title" />
              <div className="home-skel home-skel-line" />
              <div className="home-skel home-skel-line" />
              <div className="home-skel home-skel-btn" />
              <div className="home-skel home-skel-link" />
            </div>

            <div className="home-hero-right">
              <div className="home-skel home-skel-mock" />
            </div>
          </section>
        ) : (
          <>
            {/* ==================================================
                HERO
            ================================================== */}
            <section className="home-hero">
              <div className="home-hero-left">
                {logado ? (
                  <>
                    <h1 className="home-title">
                      Bem-vindo de volta{nome ? `, ${nome}` : ""}.
                    </h1>
                    <p className="home-subtitle">
                      Seu acompanhamento continua de onde você parou.
                    </p>

                    <div className="home-cta">
                      <Link
                        to="/painel"
                        className="home-btn home-btn--primary"
                      >
                        Acessar Painel
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    <h1 className="home-title">
                      NutriFácil — acompanhamento inteligente para emagrecimento
                    </h1>
                    <p className="home-subtitle">
                      Metas automáticas, registro simples de refeições e um
                      assistente com IA para te orientar todos os dias.
                    </p>

                    <div className="home-cta">
                      <a
                        href="/teste"
                        className="home-btn home-btn--primary"
                      >
                        Começar teste grátis
                      </a>

                      <Link
                        to="/login"
                        className="home-btn home-btn--ghost"
                      >
                        Já tem conta? Entrar
                      </Link>
                    </div>
                  </>
                )}

                <div className="home-badges">
                  <span className="home-badge">Metas inteligentes</span>
                  <span className="home-badge">Registro diário</span>
                  <span className="home-badge">IA para dúvidas</span>
                </div>
              </div>
            </section>

            {/* ==================================================
                SEÇÃO: O QUE O APP FAZ
            ================================================== */}
            <section className="home-section">
              <h2 className="home-section-title">O que o NutriFácil faz</h2>
              <p className="home-section-subtitle">
                Um sistema simples de usar, mas completo para manter
                consistência.
              </p>

              <div className="home-grid">
                <article className="home-feature">
                  <div className="home-feature-icon">⚙️</div>
                  <h3 className="home-feature-title">Metas automáticas</h3>
                  <p className="home-feature-text">
                    Defina seu objetivo e acompanhe metas de forma clara no dia
                    a dia.
                  </p>
                </article>

                <article className="home-feature">
                  <div className="home-feature-icon">🍽️</div>
                  <h3 className="home-feature-title">Registro simples</h3>
                  <p className="home-feature-text">
                    Registre refeições com rapidez e visualize progresso com
                    facilidade.
                  </p>
                </article>

                <article className="home-feature">
                  <div className="home-feature-icon">🤖</div>
                  <h3 className="home-feature-title">Assistente com IA</h3>
                  <p className="home-feature-text">
                    Tire dúvidas e receba orientação para manter o foco todos os
                    dias.
                  </p>
                </article>
              </div>
            </section>

            {/* ==================================================
                FAQ
            ================================================== */}
            <section className="home-section home-section--faq">
              <h2 className="home-section-title">Perguntas rápidas</h2>

              <div className="home-faq">
                <details className="home-faq-item">
                  <summary className="home-faq-q">
                    Como funciona o teste grátis?
                  </summary>
                  <p className="home-faq-a">
                    O teste grátis permite conhecer o funcionamento do
                    NutriFácil antes de liberar o acesso completo.
                  </p>
                </details>

                <details className="home-faq-item">
                  <summary className="home-faq-q">
                    Preciso informar cartão para começar?
                  </summary>
                  <p className="home-faq-a">
                    Não. Você pode iniciar o teste grátis sem pagamento e
                    decidir depois se deseja continuar.
                  </p>
                </details>

                <details className="home-faq-item">
                  <summary className="home-faq-q">
                    A IA substitui um profissional?
                  </summary>
                  <p className="home-faq-a">
                    A IA auxilia com orientações e dúvidas, mas não substitui
                    acompanhamento profissional quando necessário.
                  </p>
                </details>

                <details className="home-faq-item">
                  <summary className="home-faq-q">
                    Meus dados ficam seguros?
                  </summary>
                  <p className="home-faq-a">
                    Sim. Seus dados ficam protegidos e só são exibidos após
                    login no painel.
                  </p>
                </details>
              </div>
            </section>

            {/* ==================================================
                CTA FINAL
            ================================================== */}
            {!logado && (
              <section className="home-cta-final">
                <div className="home-cta-final-inner">
                  <h2 className="home-cta-final-title">
                    Pronto para começar?
                  </h2>
                  <p className="home-cta-final-text">
                    Experimente o NutriFácil e veja como é acompanhar metas com
                    clareza.
                  </p>

                  <div className="home-cta">
                    <a
                      href="/teste"
                      className="home-btn home-btn--primary"
                    >
                      Começar teste grátis
                    </a>

                    <Link
                      to="/login"
                      className="home-btn home-btn--ghost"
                    >
                      Já tem conta? Entrar
                    </Link>
                  </div>
                </div>
              </section>
            )}
          </>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Home;
